var now = +new Date();
var index = 0;
export default function uid() {
  // eslint-disable-next-line no-plusplus
  return "rc-upload-".concat(now, "-").concat(++index);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/node_modules/rc-upload/es/uid.js
// module id = 2945
// module chunks = 0